module.exports = __webpack_public_path__ + "img/girl.d92567bb.webp";